export enum LoginProvider {
  // login using google account
  Google = 'google',
  // login using email and password
  Email = 'email',
  // login using device id (mobile app only)
  Device = 'device',
}

export enum UserRole {
  // normal user
  User = 'user',
  // user with administration privileges
  Admin = 'admin',
}
